import React from "react";
import PropTypes from "prop-types";
import { MenuItem } from "@chakra-ui/react";

const DataTableActionItem = (props) => (
  <MenuItem {...props}>{props.children}</MenuItem>
);

DataTableActionItem.propTypes = {
  children: PropTypes.node,
};

export default DataTableActionItem;
